<template>
  <div class="loadingPage">
    <!-- <loading color="#fff"/> -->
    <loading-circle  color="#222" />
  </div>
</template>

<script>
import loading from './loading.vue'
import LoadingCircle from './loadingCircle.vue'
export default {
  components: { loading, LoadingCircle },
  name: 'loadingPage',
  props: {
    msg: String
  },
  data(){
    return{
      
    }
  },mounted() {
    
  },
  methods: {
    
  },
}
</script>
<style scoped >
  .loadingPage{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0,0,0,0.3);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>